import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/park-spcod/xpscarrier/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getCarrierPage = (current, size, params) => {
  return request({
    url: '/api/park-spcod/xpscarrier/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/park-spcod/xpscarrier/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/park-spcod/xpscarrier/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const updatestatus = (id) => {
  return request({
    url: '/api/park-spcod/xpscarrier/updatestatus/'+id,
    method: 'post'
  })
}
   
export const add = (row) => {
  return request({
    url: '/api/park-spcod/xpscarrier/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/park-spcod/xpscarrier/submit',
    method: 'post',
    data: row
  })
}

